import Vue from 'vue';
import VueBemCn from 'vue-bem-cn';
import Vuebar from 'vuebar';
import { Layout, Button, FormInput } from 'bootstrap-vue/es/components';

import App from './App.vue';
import router from './router';
import store from './store';
import './styles.scss';

/* Import global components */
import SvgIcon from '@/components/SvgIcon';

Vue.config.productionTip = false;

Vue.use(VueBemCn);
Vue.use(Layout);
Vue.use(Button);
Vue.use(FormInput);
Vue.use(Vuebar);

Vue.component('svg-icon', SvgIcon);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
